import React from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'reactstrap'

import NavigationItem from './NavigationItem'
import isAuthorised from 'features/auth/isAuthorised'

import './Navigation.scss'

const ProtectedNavigationItem = ({ route, roles }) => {
    return isAuthorised(route.roles, roles) ? (
        <NavigationItem
            key={ `navigation-item-${route.navPath ?? route.path}` }
            { ...route }
        />
    ) : null
}

ProtectedNavigationItem.propTypes = {
    route: PropTypes.object,
    roles: PropTypes.array
}

const navigationItems = ( routes, roles ) => {
    return routes.map(route => (
        <ProtectedNavigationItem
            key={ `navigation-item-${route.navPath ?? route.path}` }
            route={ route } roles={ roles } />
    ))
}

const Navigation = props => {
    const items = navigationItems(props.routes, props.roles)

    return (
        <Nav navbar>
            { items }
        </Nav>
    )
}

Navigation.propTypes = {
    routes: PropTypes.array,
    roles: PropTypes.array
}

Navigation.defaultProps = {
    routes: [],
    roles: []
}

export default Navigation
